// The public feedback page for one run of a training:
// /feedback/[slug]/[edition number] — the link each edition hands out.

import { createFileRoute, notFound } from "@tanstack/react-router";
import {
	FeedbackPage,
	feedbackHead,
} from "#/components/questionnaire/feedback-page";
import { getPublicQuestionnaire } from "#/lib/questionnaire-server";

export const Route = createFileRoute("/feedback/$slug_/$edition")({
	loader: ({ params }) => {
		const edition = Number(params.edition);
		// "/feedback/x/abc" is a broken link, not a closed form.
		if (!Number.isInteger(edition) || edition < 1) throw notFound();
		return getPublicQuestionnaire({ data: { slug: params.slug, edition } });
	},
	head: ({ loaderData }) => feedbackHead(loaderData),
	component: EditionFeedbackPage,
});

function EditionFeedbackPage() {
	return <FeedbackPage data={Route.useLoaderData()} />;
}
